export default {
	lot_id: "",
	floorplan: 0,
	floorplan_label: "",
	price: "",
	sqft: "",
	realtor_involved: "",
	realtor: null,
	realtor_office: null,
	realtor_office_team: null,
	realtor_office_office: null, // brokerages office under realtor_brokerages
	realtor_phone: "",
	realtor_email: "",
	estimated_closing: 0,
	sale_date: 0,
	primary_first: "",
	primary_last: "",
	primary_email: "",
	co_first: "",
	co_last: "",
	has_co: true,
	comments: "",
	beds: "",
	full_baths: "",
	stories: "",
	garage: "",
	half_baths: "",
	elevation: "",
	traffic_source: "",
	salesperson: "",
	floorplan_base_price: "",
}